import {
  DateUtils
} from "./chunk-K54LRIUM.mjs";

// lib/components/search-panel/search-condition-panel/search-condition-structure.ts
var initCurrentSearchConditionItem = (item) => {
  switch (item.type) {
    case "text":
      return { type: item.type, name: item.name, value: "" };
    case "select":
      return { type: item.type, name: item.name };
    case "multi-select":
      return { type: item.type, name: item.name, value: [] };
    case "term":
      return {
        type: item.type,
        name: item.name,
        value: [void 0, void 0],
        level: "day",
        mode: "point"
      };
  }
};
function inputValueToString(value, item) {
  switch (value.type) {
    case "text":
      return value.value;
    case "select": {
      if (value.type !== item.type || value.name !== item.name) {
        return "";
      }
      const select = item.options.find(
        (v) => value.value && v.value === value.value
      );
      return select ? `${select.label}` : "";
    }
    case "multi-select": {
      if (value.type !== item.type || value.name !== item.name) {
        return "";
      }
      const selects = item.options.filter((v) => value.value.includes(v.value));
      return selects.map((v) => v.label).join("/");
    }
    case "term":
      return `${value.value[0] ? DateUtils.formatToMMdd(value.value[0]) : ""}\uFF5E${value.value[1] ? DateUtils.formatToMMdd(value.value[1]) : ""}`;
  }
}

export {
  initCurrentSearchConditionItem,
  inputValueToString
};
